import { CACHE_MANAGER } from "../utils.js";
import NotImplementedError from "./NotImplementedError.js";

const THROTTLE_DELAY = 400;
export default class ResourceManager {
  constructor(defaultSize) {
    this.baseUrl = null;
    this.highQualityThrottle = null;
    this.maxQualityThrottle = null;
    this.defaultSize = defaultSize;
    this._onHighQualityImageReady = () => {
      throw new NotImplementedError();
    };
    this._onMaxQualityImageReady = () => {
      throw new NotImplementedError();
    };
  }

  setBaseUrl(url) {
    this.baseUrl = url;
  }

  setDefaultSize(size) {
    this.defaultSize = size;
  }

  getFullResUrl(image) {
    return image.url || `${this.baseUrl}/${image.hash}`;
  }

  /**
   *
   * @param {object} image
   * @returns {*}
   */
  getFrame(image) {
    const highQualityUrl = image.url || `${this.baseUrl}/${image.hash}.1920`;

    if (CACHE_MANAGER.isReady(highQualityUrl)) {
      return CACHE_MANAGER.get(highQualityUrl);
    }

    clearTimeout(this.highQualityThrottle);
    this.highQualityThrottle = setTimeout(() => {
      CACHE_MANAGER.image(highQualityUrl)
        .then((cached) => {
          image.highQualityImage = cached;
          this._onHighQualityImageReady(image);
        })
        .catch((e) => {
          console.error("Error loading high quality image:", e);
        });
    }, THROTTLE_DELAY);

    const fallback = `${this.baseUrl}/${image.hash}.${this.defaultSize}`;

    return CACHE_MANAGER.get(fallback) ?? fallback;
  }

  upscale(image) {
    clearTimeout(this.maxQualityThrottle);
    this.maxQualityThrottle = setTimeout(() => {
      const maxQualityUrl = this.getFullResUrl(image);

      if (CACHE_MANAGER.isReady(maxQualityUrl)) {
        /*
         * APP-389 Fix missing blob url that is observed in Spinner Studio.
         * This is needed to take care of the case where an image use a url
         * property instead of a hash property (like normal spinner json files)
         */
        image.maxQualityImage = CACHE_MANAGER.get(maxQualityUrl);
        return this._onMaxQualityImageReady(image);
      }

      CACHE_MANAGER.image(maxQualityUrl, true)
        .then((cachedImage) => {
          image.maxQualityImage = cachedImage;
          this._onMaxQualityImageReady(image);
        })
        .catch((e) => {
          console.error("Error loading max quality image:", e);
        });
    }, THROTTLE_DELAY);
  }

  onHighQualityImageReady(callback) {
    this._onHighQualityImageReady = callback;
  }

  onMaxQualityImageReady(callback) {
    this._onMaxQualityImageReady = callback;
  }
}
